/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 16:11:55
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-01-11 14:58:41
 * @Description: FileDescription
 */

import dbc from '@/api/authority';
import dba from '@/api/appManage/appManage';

export default {
  namespaced: true,
  state: {
    // 角色管理页面数据模型
    roleList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    systemSources: [],
    roleAllListObj: [],
    // roleSources: [],
    // 给角色设置权限，获取所有权限菜单
    roleMenus: [],
    // 用户管理页面数据模型
    userList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 成本中心用户数据
    costUserList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 用户成本中心用户数据
    costUserListPerson: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 组织架构数组，不分页
    deptList: [],
    // 操作日志列表页面数据模型
    optLog: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 登录日志列表页面数据模型
    loginLog: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // API日志列表页面数据模型
    apiLog: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    menu: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 搜索菜单关键字
    menuKeyword: '',
    sideBarMenu: [],
    // 权限数组
    permissionList: [],
  },
  actions: {
    /**
     *
     * 系统管理-菜单管理
     */

    /**
     * 菜单管理 获取所有菜单数据，数据不分页
     * @param {*} param0
     * @param {*} param
     */
    getMenuList({ commit }, param) {
      return dbc.getMenuList(param).then((content) => {
        commit('setMenuList', content);
      });
    },

    /* 系统类型数据源 */
    getSystemSources({ commit }, param) {
      return dbc.getAppList(param).then((content) => {
        commit('setSystemSources', content);
        return content;
      });
    },

    /* 系统类型数据源 */
    getSystemTypes(store, param) {
      return dbc.getSystemTypes(param);
    },
    /**
     * 添加一个菜单
     * @param {*} store
     * @param {*} param
     */
    addMenuItem(store, param) {
      return dbc.addMenuItem(param);
    },

    /**
     * 编辑单个菜单
     * @param {*} store
     * @param {*} param
     */
    editMenuItem(store, param) {
      return dbc.editMenuItem(param);
    },

    /**
     * 删除单个菜单项目
     * @param {*} store
     * @param {*} param
     */
    deleteMenuItem(store, param) {
      return dbc.deleteMenuItem(param);
    },

    /**
     * 批量删除多个菜单项目
     * @param {*} store
     * @param {*} param
     */
    deleteMenuItems(store, param) {
      return dbc.deleteMenuItems(param);
    },

    /**
     * 给角色设置权限，读取角色菜单数据
     * @param {*} param0
     * @param {*} param
     */
    getRoleMenus({ commit }, param) {
      return dbc.getRoleMenus(param).then((content) => {
        commit('setRoleMenus', content);
      });
    },

    /**
     * 给角色设置权限
     * @param {*} store
     * @param {*} param
     */
    createRoleRight(store, param) {
      return dbc.createRoleRight(param);
    },

    /**
     * 给角色设置权限
     * @param {*} store
     * @param {*} param
     */
    modifyRoleRight(store, param) {
      return dbc.modifyRoleRight(param);
    },

    /**
     * 左侧memu菜单数据
     * @param {*} param0
     * @param {*} param
     */
    getSideBarMenu({ commit }, param) {
      return dbc.getSideBarMenu(param).then((content) => {
        commit('setSideBarMenu', content);
      });
    },

    /* 内部组织数据 */
    getInsidePeople(store, param) {
      return dbc.getInsidePeople(param);
    },

    /* 外部组织数据 */
    getRolePeopleList(store, param) {
      return dbc.getRolePeopleList(param);
    },

    /* 外部组织数据 */
    getOutsidePeople(store, param) {
      return dbc.getOutsidePeople(param);
    },

    /* 通过用户id查找用户list */
    getPeopleByIds(store, param) {
      return dbc.getPeopleByIds(param);
    },

    /* 用户管理-密码重置 */
    resetPassword(store, param) {
      return dbc.resetPassword(param);
    },

    /* 用户管理-生成密钥 */
    createKeyFun(store, param) {
      return dbc.createKeyFun(param);
    },

    /* 用户管理-组织下发 */
    organizeDevelopmentFun(store, param) {
      return dbc.organizeDevelopmentFun(param);
    },

    /* 用户管理-启用、禁用 */
    handleDisabledPeople(store, param) {
      return dbc.handleDisabledPeople(param);
    },

    /* 用户管理-导入-下载模版 */
    dowmloadUserTemp(store, param) {
      return dbc.dowmloadUserTemp(param);
    },
  },
  mutations: {
    setRoleList(state, content) {
      const { list, pageNum, total } = content.page;
      state.roleList.list = list;
      state.roleList.pageNum = pageNum;
      state.roleList.total = total;
    },

    setRoleAllList(state, content) {
      const returnObj = content.data;
      state.roleAllListObj = returnObj;
    },

    setSystemSources(state, content) {
      const returnArr = content.list;
      state.systemSources = returnArr;
    },

    setRoleMenus(state, content) {
      const { list } = content;
      state.roleMenus = list;
    },
    setRoleParamObj(state, content) {
      state.roleParamObj = content;
    },
    setUserList(state, content) {
      const { list, pageNum, total } = content.page;
      state.userList.list = list;
      state.userList.pageNum = pageNum;
      state.userList.total = total;
    },
    setCostUserList(state, content) {
      const { list, pageNum, total } = content.page;
      state.costUserList.list = list;
      state.costUserList.pageNum = pageNum;
      state.costUserList.total = total;
    },
    setPersonCostUserList(state, content) {
      const { list, pageNum, total } = content.page;
      state.costUserListPerson.list = list;
      state.costUserListPerson.pageNum = pageNum;
      state.costUserListPerson.total = total;
    },

    updateDeptList(state, content) {
      state.userList.list.find((user) => {
        if (user.id === content.id) {
          user.roletype = content.roletype;
          return true;
        }
        return false;
      });
    },

    setDeptList(state, content) {
      const { list } = content;
      state.deptList = list;
    },

    // setRoleSources(state, content) {
    //   state.roleSources = content.list;
    // },

    setOptLogList(state, content) {
      const { list, pageNum, total } = content.page;
      state.optLog.list = list;
      state.optLog.pageNum = pageNum;
      state.optLog.total = total;
    },

    setLoginLogList(state, content) {
      const { list, pageNum, total } = content.page;
      state.loginLog.list = list;
      state.loginLog.pageNum = pageNum;
      state.loginLog.total = total;
    },

    setApiLogList(state, content) {
      const { list, pageNum, total } = content.page;
      state.apiLog.list = list;
      state.apiLog.pageNum = pageNum;
      state.apiLog.total = total;
    },

    // 菜单管理
    setMenuList(state, content) {
      const { data } = content;
      state.menu.list = data;
    },

    // 左侧memu菜单数据
    setSideBarMenu(state, content) {
      const { menuList, permissionList } = content.data;
      state.sideBarMenu = menuList;
      state.permissionList = permissionList;
    },
    // 设置左侧搜索关键字
    searchMenu(state, keyword) {
      state.menuKeyword = keyword;
    },

    setDetail(state, prod) {
      state.detail = prod.data;
    },
  },
};
